import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Inject, Injectable, NgModule } from '@angular/core';
import {
  AuthModule as OidcAuthModule,
  OpenIdConfiguration,
  StsConfigLoader,
  StsConfigStaticLoader,
} from 'angular-auth-oidc-client';
import { AuthRoutingModule } from './auth-routing.module';
import { CallbackComponent } from './callback.component';
import { LogoutComponent } from './logout.component';
import { AUTH_CONFIG, AuthConfig } from '@config/auth-config.types';
import { ApiInterceptor } from '@interceptors/api.interceptor';

const openIdConfigurationFactory = (configService: OpenIdConfigurationService) =>
  new StsConfigStaticLoader(configService.getConfig());

@Injectable({ providedIn: 'root' })
class OpenIdConfigurationService {
  constructor(@Inject(AUTH_CONFIG) private readonly authConfig: AuthConfig) {}

  getConfig(): OpenIdConfiguration {
    const applicationPort = location.port ? `:${location.port}` : '';
    const applicationUrl = `${location.protocol}//${location.hostname}${applicationPort}`;

    return {
      authority: this.authConfig.Auth.AuthorityUrl,
      redirectUrl: `${applicationUrl}/callback`,
      postLogoutRedirectUri: applicationUrl,
      clientId: this.authConfig.Auth.ClientId,
      scope: this.authConfig.Auth.Scopes,
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      customParamsAuthRequest: {
        prompt: this.authConfig.Auth.ClientId === 'leerlinginbeeld-fe' ? '' : 'login' // Prompt login niet nodig in lib omdat we de login
      },                                                                              // pagina niet nogmaals willen benaderen als we
      renewTimeBeforeTokenExpiresInSeconds: 60,                                       // via Thinkwise al zijn ingelogd.
      triggerAuthorizationResultEvent: true,
      // De authenticatieserver publiceert endpoints op *.doe.nl maar geeft als
      // issuer *.cito.nl terug. De nieuwe issuer-validatie van angular-auth-oidc-client
      // (v21) faalt hierop; uitschakelen zodat de discovery zoals voorheen werkt.
      strictIssuerValidationOnWellKnownRetrievalOff: true,
    };
  }
}

@NgModule({
  imports: [
    OidcAuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: openIdConfigurationFactory,
        deps: [OpenIdConfigurationService],
      },
    }),
    AuthRoutingModule,
  ],
  exports: [OidcAuthModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
  ],
  declarations: [CallbackComponent, LogoutComponent],
})
export class AuthenticationModule {}
